import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { dashboardSummaryAPI } from "../../api/attendance";

const EmployeeDashboard = () => {
  const [summary, setSummary] = useState({
    present: 0,
    absent: 0,
    late: 0,
    halfDay: 0,
    totalDays: 0,
  });

  const holidays = [
  { date: "Jan 26", name: "Republic Day" },
  { date: "Aug 15", name: "Independence Day" },
  { date: "Oct 2", name: "Gandhi Jayanti" },
  { date: "Dec 25", name: "Christmas" },
];

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await dashboardSummaryAPI();
      setSummary(res.data);
    } catch (err) {
    }
  };

  const chartData = [
    { name: "Present", value: summary.present },
    { name: "Absent", value: summary.absent },
    { name: "Late", value: summary.late },
    { name: "Half Day", value: summary.halfDay },
  ];

  return (
    <div className="container-admin">

      <div className="empdash-header">
        <h2>Employee Attendance Overview</h2>
        <p>This Month Performance Summary</p>
      </div>

      {/* ===== SUMMARY CARDS ===== */}
      <div className="empdash-card-grid">

        <div className="empdash-card card-present">
          <h4>Present</h4>
          <span>{summary.present}</span>
        </div>

        <div className="empdash-card card-absent">
          <h4>Absent</h4>
          <span>{summary.absent}</span>
        </div>

        <div className="empdash-card card-late">
          <h4>Late</h4>
          <span>{summary.late}</span>
        </div>

        <div className="empdash-card card-half">
          <h4>Half Day</h4>
          <span>{summary.halfDay}</span>
        </div>

        <div className="empdash-card card-total">
          <h4>Total Working Days</h4>
          <span>{summary.totalDays}</span>
        </div>

      </div>

      {/* ===== MAIN CONTENT GRID ===== */}
      <div className="empdash-main-grid">

        {/* GRAPH */}
        <div className="empdash-chart-box">
          <h3>Attendance Analytics</h3>

          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#6366f1" radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>

        </div>

        {/* GOVERNMENT HOLIDAYS */}
        <div className="empdash-holiday-box">
          <h3>Government Holidays</h3>

          <ul>
            {holidays.map((holiday, index) => (
              <li key={index}>
                <div>
                  <span className="holiday-date">{holiday.date}</span>
                  <p>{holiday.name}</p>
                </div>
              </li>
            ))}
          </ul>

        </div>

      </div>

    </div>
  );
};

export default EmployeeDashboard;